export default class PageSeparator {}
